module.exports = {
  //交互反馈
  request: {
    201: "매개변수 오류",
    202: "계정이 비어 있으면 안 됩니다.",
    203: "비밀번호 가 비어 있 으 면 안 됩 니 다.",
    204: "계 정 오류",
    205: "암호 오류",
    206: "정보 오류, 관리자 에 게 연락 하 세 요.",
    207: "화폐 종류 가 존재 하지 않 는 다.",
    208: "구 매 수량 이 범 위 를 초과 하 다",
    300: "요청 실패",
    209: "암호 가 일치 하지 않 음",
    236: "계 정 이 이미 존재 합 니 다",
    211: "원본 암호 오류",
    212: "새 암호를 입력하십시오..",
    213: "이름을 기입해 주십시오.",
    214: "성씨를 기입해 주십시오.",
    215: "증명서 종류 선택",
    216: "증명서 번호를 기입해 주십시오.",
    217: "정면 증명서 사진은 반드시 올려야 한다.",
    218: "뒷면 증명서 사진은 반드시 올려야 한다.",
    219: "국적 을 선택 하 세 요",
    220: "증명서를 들고 사진을 찍으려면 반드시 올려야 한다.",
    221: "돈세탁 반대 협의 서명 사진은 반드시 업로드해야 한다.",
    222: "잔고 가 부족 하 다",
    223: "주문 오류, 관리자 에 게 연락 하 세 요.",
    230: "선택한 화폐의 종류는 같을 수 없다",
    234: "올바른 메일박스를 사용하십시오",
    235: "인증번호가 잘못되었습니다.",
    237: "현재 계정은 아직 등록하지 않았습니다. 등록하세요",
    231: "선택한 화폐 종류는 비워둘 수 없다"
  },

  //国家
  country: {
    Usa: "미국",
    China: "중국 명사",
    korea: "대한민국",
    Japan: "한국어 공부 해요.",
    HongKong: "홍콩",
    Taiwan: "대만",
    Russia: "러시아",
    France: "프랑스",
    britain: "영국",
    Germany: "독일",
    Brazil: "브라질",
    Italy: "이태리",
    Canada: "캐나다",
    Spain: "스페인",
    Malaysia: "말레이시아",
    Singapore: "싱가폴",
    Indonesia: "인도네시아",
    Philippines: "필리핀",
    Vietnam: "월남",
    India: "인도",
    Bhutan: "부탄",
    Finland: "핀란드",
    Sweden: "스웨덴",
    Norway: "노르웨이",
    Iceland: "아이슬란드",
    Denmark: "덴마크",
    zimbabwe: "짐바브웨",
    Netherlands: "네덜란드",
    Thailand: "태국",
  },

  //证件
  certificates: {
    passport: "여권.",
    ID: "신분증",
    driverLicense: "운전면허증"
  },

  //通用
  currency: {
    loading: "로드 중",
    determine: "확정 하 다",
    cancel: "취소 하 다",
    tips: "제시 하 다",
    psdRule: "암호는 알파벳 + 숫자 조합이어야驾驶证 합니다.",
    psdLength: "암호 길이는 6비트 이상이어야 합니다.",
    loginPsdLength: "암호 길이는 8비트 이상이어야 합니다.",
    actionSuccess: "작업 성공",
    success: "성공",
    fail: "실패하다",
    passed: "검토 중",
    return: "되돌아오다"
  },

  // 登陆页
  login: {
    welComeToLogin: '로그인',
    username: "계정",
    password: "비밀번호",
    submit: "제출",
    noAccount: "계정 없음",
    register: "등록",
    forgetPassword: "비밀번호를 잊으 셨나요",
    loginSuccess: "로그인 성공",
    logoutSuccess: "종료 성공",
    enterAccount: "계정을 입력하십시오",
    enterPsw: "비밀번호를 입력하세요",
    rememberPassword: "비밀번호 기억하기"
  },

  //注册页
  register: {
    registeredAccount: "회원가입",
    mailboxRegistration: "이메일",
    mailbox: "이메일",
    setPassword: "암호 설정",
    confirmPassword: "암호 확인",
    readAgree: "나 는 이미 읽 고 동의 했다",
    userAgreement: "사용자 프로 토 콜",
    and: "과",
    privacyClause: "은신 조항",
    existingAccount: "기 존 계 정",
    signIn: '로그 인',
    registerSuccess: "등록 완료",
    pleaseRead: "사용자 계약 및 약관을 참조하십시오.",
    inviteCode: "추천 코드",
    verificationCode: "이메일 인증코드"
  },

  //忘记密码
  forgetPassword: {
    code: "이메일 인증코드",
    forgetPassword: "비밀번호를 잊어버리다",
    sendCode: "이메일 보내기"
  },

  //顶部导航栏
  nav: {
    home: "첫 페이지",
    quotation: "시세",
    transaction: "거래",
    notice: "공고",
    securityCenter: "안전 센터",
    assets: "내 자산",
    recharge: "송금하다",
    withDrawal: "인출하다",
    fundTransfer: "이동",
    orderCenter: "교역 센터",
    exchange: "교환하다",
    logOut: "계정 탈퇴",
    downloadApp: "스캔 다운로드 앱",
    moreClient: "추가 다운로드",
    chinese: "简体中文",
    traditionalChinese: "繁體中文",
    english: "English.",
    korean: "한국어",
    japanese: "日本語",
    continueToExit: "계속 종료 여부"
  },

  //首页
  home: {
    name: "코인",
    price: '가격',
    amount: "24h 가격변동",
    title: "언제 어디서나 거래 하 다",
    desc: "다 중 단말 기 는 완벽 하 게 호 환 되 어 각종 장면 의 거래 수 요 를 수시로 만족시킨다",
    text1: "실시 간 시세 수시로 보기",
    text2: "轻松买卖BTC,ETH,XRP,OKB和其他数字资产",
    text3: "관심 있 는 암호 화폐 가격 변화 경고 가 져 오기",
    text4: "비트 코 인 현물, 선물, 옵션 가격 보기",
    text5: "각 거래소 의 암호 화폐 가격 을 비교 하 다",
    title1: "글로벌 리더십",
    title2: "디지털 자산 서비스 플랫폼",
    desc2: "안전 · 안정 · 신뢰성",
    createAccount: "계정 만들기",
    text6: "디지털 화폐 여행 열기"
  },

  //行情
  quotes: {
    title: "오늘의 시장"
  },

  //安全中心
  securityCenter: {
    identityAuthentication: "개인 정보 인증",
    desc: "개인 인증을 완료하면 계정의 안전을 보호하는 데 도움이 된다.",
    go: "가다",
    loginPassword: "계정 비밀번호",
    desc1: "계 정 보안 보호 에 사용",
    edit: "수정하다",
    fundPassword: '자금 암호',
    desc2: "자금 보호를 위해",
    setUp: "설치",
    changePassword: "암호 수정",
    changePasswordAlert: "修改登录密码后24小时内禁止提币和OTC划转",
    originalPassword: "이전 암호",
    newPassword: "새 암호",
    confirmPassword: "새 암호 확인",
    setFundPassword: "자금 비밀번호 설정",
    resetFundPassword: "자금 비밀번호 재설정",
    confirmFundPassword: "자금 비밀번호 확인",
    setSuccessfully: "설정 성공"
  },

  //身份认证
  personalAuthentication: {
    identityAuthentication: "신원 확인",
    personalIdentityAuthentication: "개인 정보 인증",
    know: "알다",
    primaryCertification: "초급 인증",
    desc: "增加提币额度，24小时限额200BTC",
    advancedCertification: "고급 인증",
    submitApproval: "제출",
    agreementDownload: '돈세탁 반대 프로토콜 다운로드',
    handCertificates: "증명서를 들고 사진을 찍어서 올리세요.",
    handCertificates2: "돈세탁 반대 계약서 서명하고 사진 찍어 올리기",
    national: "국적",
    surname: "성씨",
    realname: "이름",
    papersType: "증명서 유형",
    papers: "증명서 번호",
    papersPositive: "증명서 정면 사진 올리기",
    papersReverse: "증명서 뒷면 사진을 올리다",
    pleaseEnter: "입력",
    title: "인증해야 하는 이유",
    content: "실명 인증 은 현재 의 금융 법규 나 관련 정책 을 준수 하기 위 한 것 이다.실명 인증 은 귀하 의 계좌 안전 을 보호 하고 일부 사기 수단 을 피 하 는 데 도움 이 됩 니 다.저 희 는 귀하 의 정 보 를 엄 격 히 비밀 로 할 것 입 니 다.",
    title2: "暂时不支持哪些国家",
    content2: "실명 인증 은 현재 의 금융 법규 나 관련 정책 을 준수 하기 위 한 것 이다.실명 인증 은 귀하 의 계좌 안전 을 보호 하고 일부 사기 수단 을 피 하 는 데 도움 이 됩 니 다.저 희 는 귀하 의 정 보 를 엄 격 히 비밀 로 할 것 입 니 다.",
    verificationCertification: "고급인증 먼저완료",
    authentication: "지금 인증",
    PrimaryAuditPassed: "기본인증통과",
    level0: "존재했다",
    level1: "기본인증검토",
    level2: "기본인증검토 통과하지못했다",
    level3: "기본인증검토 통과",
    level4: "고급인증 검토중인",
    level5: "고급인증 실패",
    level6: "고급인증통과",
  },

  //交易
  transaction: {
    pleaseSelect: "선택해주세요",
    price: "가격",
    requiredMargin: "필요한 여백",
    closingFee: "마감 수수료",
    stopSurplus: "이익을 중지",
    default: "기본값",
    stopLoss: "손절매",
    purchase: "구입",
    currentPosition: "현재 소유",
    historicalContract: "역사적 계약",
    order: "주문 번호",
    creationTime: "생성 시간",
    transactionType: "거래 유형",
    buyUp: "구매/롱",
    buyFall: "구매/숏",
    num: "수량",
    bond: "보증금",
    serviceCharge: "수수료",
    ClosingProfitLoss: "결산 이익",
    netProfitLoss: "순이익 및 손실",
    orderStatus: "주문 상태",
    operation: "작동하다",
    compulsoryLiquidation: "강제청산",
    forceClosing: "포지션을 청산하시겠습니까??",
    pleaseLogin: "아직 로그인하지 않으셨습니다. 먼저 로그인해주세요!",
    buyCurrentPrice: "현재 통화 가격은 0입니다.",
    charged: "폐장시간",
    buildingTime: "영업시간",
    buildingPrice: "개점가",
    currencyPriceNew: "종가",
    heightPrice: "24 시간 최고",
    lowPrice: "24 시간 최저",
    latestTransaction: "최신 거래",
    FloatingPL: "변동 손익",
    storageFee: "보관료",
    status1: "자동 이윤 정지",
    status2: "자동 손실 방지 창고 정리",
    status3: "수동으로 이윤을 정지하고 창고를 평정하다.",
    status4: "수동 파손 방지 창고 정리",
    status5: "실행 중",
  },

  assets: {
    accountOverview: "계정 개요",
    currencyAccount: "화폐 계좌",
    contractAccount: "계약 계좌",
    transfer: "이동",
    withdrawMoney: "인출하다",
    chargeMoney: "송금하다",
    Cryptocurrency: "암호 화폐",
    currency: "화폐.",
    available: "사용가능",
    valuation: "어림잡다",
    operation: "작동하다",
    chargingCurrency: "입금 통화 선택",
    currencyType: "통화",
    alert1: "최소 충전 금액",
    alert2: "최소 금액 미만의 입금액은 계좌에 입금되지 않으며 환불되지 않습니다.",
    ChargingInfo: "통화 정보 확인",
    ChargingNetwork: "예금 네트워크",
    rule2: "위 주소로 재충전 후 전체 네트워크 노드의 확인이 필요하며, 12번의 네트워크 확인 후 적립되며, 12번의 네트워크 확인 후 코인 출금이 가능합니다.",
    rule3_btc: "최소 입금액: 0.01BTC, 최소 입금액보다 적은 입금액은 계좌로 입금되지 않으며, 환불되지 않습니다.",
    rule3_usdt: "최소 충전 금액: 300USDT, 최소 충전 금액 미만은 계정에 적립되지 않으며 환불되지 않습니다.",
    rule3_eth: "최소 입금액: 0.15ETH, 최소 입금액보다 적은 입금액은 계좌에 입금되지 않으며 환불되지 않습니다.",
    rule4: "충전 주소는 자주 변경되지 않으며 충전이 가능하며, 변경 사항이 있을 경우 홈페이지 공지 또는 이메일을 통해 안내해 드리겠습니다.",
    rule5: "정보가 변조되거나 유출되지 않도록 컴퓨터 및 브라우저의 보안을 반드시 확인하십시오.",
    ChargingRecord: "예금 기록",
    time: "시각",
    netWorkAddress: "웹 사이트 주소",
    selectWithdrawalCurrency: "출금 통화 선택",
    ol1: "자금의 안전 확보를 위해 계정 보안 정책이 변경되거나 비밀번호가 변경될 경우 수동으로 출금을 검토하므로 직원이 이메일로 연락을 드릴 때까지 기다려 주시기 바랍니다.",
    ol2: "정보가 변조되거나 유출되지 않도록 컴퓨터 및 브라우저의 보안을 반드시 확인하십시오.",
    withdrawalInfo: "출금 정보 입력",
    withdrawAddress: "출금 주소",
    withdrawalNetwork: "출금 네트워크",
    withdrawalNum: "인출 횟수",
    minWithdrawalNum: "최소 출금 금액",
    actualArrival: "실제로 도착했다",
    notLessThan: "적어도",
    viewAll: "모든 통화 보기",
    withdrawalRecord: "출금기록",
    transferCurrency: "송금 통화를 선택하세요.",
    transferNum: "환승 횟수",
    from: "~에서",
    to: "도착하다",
    transferRecord: "전송 기록",
    exceedBalance: "사용 가능한 수량보다 클 수 없습니다.",
    use: "사용",
    convertInto: "로 변환하다",
    exchangeRate: "환율",
    exChangeAlert: "비율: 2% | 결석 지불",
    exchangeInstructions: "교환 메모",
    desc1: "자금의 교환은 시장심도 및 시장상황에 영향을 받으며, 가격은 수시로 변동되오니, 주문 확정 후 최종 금액을 참고하여 주시기 바랍니다.",
    desc2: "위험 통제 시스템의 요구 사항에 따라 자금 교환이 제3자 위험 통제를 유발하는 경우 교환 사용자는 감사인과 협력하여 관련 검토를 완료해야 합니다.검토를 완료할 수 없는 경우 주문은 환불됩니다. 당신은 적어도 한 달 (30 일)",
    desc3: "자금 교환은 사적인 행위임을 반드시 확인하시고, 디지털 화폐를 사용하여 피라미드 사기, 불법자금 모금, 사기 등 불법 행위에 가담하지 않도록 해주시기 바랍니다. 높은 이자를 약속하는 모든 불법 프로젝트에 주의하시기 바랍니다. 보고하고, 속임수에 주의하여 불필요한 손실을 피하십시오.",
    exchangeRecord: "교환 기록",
    useCurrency: "통화 사용",
    exchangeCurrency: "환전",
    AbsenteeismFee: "장기 결석",
    exchangeQuantity: "교환 횟수",
    paymentPassword: "결제 비밀번호를 입력해주세요",
    currencyNoSame: "화폐의 종류는 같을 수없다"
  },

  // 二期
  iteration: {
    contractMarket: "계약시장",
    quotationDesc: "전디지털화폐시세",
    accountOverview: "계정총람",
    accountOverviewDesc: "계좌자금상황총람",
    all: "모조리",
    userCenter: "개인센터",
    viewInfo: "개인정보보기",
    setPsdDesc: "강도 높은 비밀번호를 설정하면 계정 전쟁에 유리하다",
    homeTitle: "전 세계 1위의 잠재력 화폐 거래소",
    homeDesc: "전 세계에서 앞장서는 화폐 거래 팀, 독특한 잠재력의 거래소",
    homeTitle2: "최대 소셜 트레이딩 플랫폼",
    homeDesc2: "글로벌 암호화폐 투자자들과 교류하고 신뢰할 만한 최신 암호화폐 뉴스를 접하세요",
    homeTitle3: "모두의 거래소",
    homeDesc3: "플랫폼은 모든 유형의 투자자들을 위해 만들어졌으며, 투자자가 선호하는 채널과 언어로 연중무휴 24시간 세계적 수준의 서비스를 제공합니다",
    homeTitle4: "언제 어디서든 거래하세요",
    homeDesc4: "앱과 웹사이트는 쉽게 거래를 시작할 수 있도록 지원합니다",
    homeTitle5: "비트코인은 무엇인가요?",
    homeDesc5: "비트코인은 중앙 은행 또는 단일 관리자가 없는 분권화된 디지털 통화입니다. 비트코인은 P2P 네트워크를 통해 중개인 없이 개인끼리 직접 거래됩니다",
    homeTitle6: "단돈 1달러로 거래를 시작할 수 있나요?",
    homeDesc6: "은 최저 1달러로 다양한 거래 및 금융 상품을 통해 사용자가 실질적인 경험을 쌓을 수 있도록 지원합니다",
    homeTitle7: "BitFuy은 안전한가요?",
    homeDesc7: "BitFuy은 세계에서 가장 정교한 보안 기술 및 유지보수 팀을 보유하고 있으며, 보안 시스템을 지속적으로 업그레이드하여 사용자 자산 및 계정을 보호합니다",
    homeTitle8: "법정통화와 암호화폐간 환전 한도가 있나요?",
    homeDesc8: "BitFuy은 법정통화와 암호화폐간 환전에 제한을 두지 않으며",
    homeTitle9: "당신의 암호화폐 여정을 지금 시작하세요!",
    homeDesc9: "BitFuy 앱과 웹사이트로 거래가 전에 없이 쉬워집니다",
    digitalCurrency: "디지털 화폐",
    qualityInformation: "고품질 자문",
    globalInvestor: "글로벌 투자자",
    internationalCommunity: "국제 공동체",
    countriesCovered: "국가를 덮어쓰다",
    transactionText: "디지털 화폐 충전 또는 구매 후 거래 하세요",
    cumulative: "누계",
    realTimeTransaction: '실시간 거래',
    balance: "잔고",
    totalMargin: "총 보증금",
    transferQuantityTips: "회전 수량은 0 이상이어야 합니다.",
    notCertified: "인증되지 않음",
    certified: "인증됨",
    underCertification: "인증 중",
    digitalCurrencyTransactions: "디지털 화폐 거래",
    setCapitalPsw: "자금 비밀번호 설정",
    authenticationTips: "기본 인증 필요",
    than: "값이 0보다 커야 합니다."
  }
}